
import { Property } from '../types';

const PROXY_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwQXmIH_ALiWal4PpBximO5Qu0-uUPfItG3_CvEAy4gtXe6Bx7xTBJ8eNO4pzz-whEN/exec";
const REFERRAL_WORKFLOW_ID = "0f106461-9926-46ff-b31e-69b6a9ca77d0";

export interface ReferralFormData {
  nombre_broker: string;
  tipo_documento_broker: string;
  numero_documento_broker: string;
  countryCode_broker: string;
  telefono_broker: string;
  email_broker: string;
  nombre_cliente: string;
  tipo_documento_cliente: string;
  numero_documento_cliente: string;
  countryCode_cliente: string;
  telefono_cliente: string;
  email_cliente: string;
  ingresos_cliente: string;
}

export const submitReferralToN8n = async (
  formData: ReferralFormData,
  selectedProperty: Property | null,
  selectedBank: string | null
) => {
  const isCc = selectedProperty?.codigo.startsWith('183150');
  const shortCode = isCc ? 'c' : 'b';
  const publicUrl = selectedProperty 
    ? `${window.location.origin}/share/${selectedProperty.id}?collection=${shortCode}` 
    : 'N/A';

  const innerPayload = {
    nombre_completo_broker: formData.nombre_broker,
    tipo_documento_broker: formData.tipo_documento_broker,
    numero_documento_broker: formData.numero_documento_broker,
    numero_telefono_broker: `${formData.countryCode_broker}${formData.telefono_broker}`,
    correo_electronico_broker: formData.email_broker,
    nombre_completo_cliente: formData.nombre_cliente,
    tipo_documento_cliente: formData.tipo_documento_cliente,
    numero_documento_cliente: formData.numero_documento_cliente,
    numero_telefono_cliente: `${formData.countryCode_cliente}${formData.telefono_cliente}`,
    correo_electronico_cliente: formData.email_cliente,
    banco_financiador: selectedBank,
    ingresos_cliente: formData.ingresos_cliente,
    codigo_inmueble: selectedProperty?.codigo || 'Referido General',
    precio: selectedProperty?.precio_venta || 0,
    tipo_inmueble: selectedProperty?.tipoinmueble || 'N/A',
    direccion: selectedProperty?.direccion || 'N/A',
    ciudad: selectedProperty?.ciudad || 'N/A',
    localidad: selectedProperty?.localidad || 'N/A',
    barrio: selectedProperty?.neighborhoodName || 'N/A',
    propietario: selectedProperty?.owner || 'N/A',
    url: publicUrl
  };

  const finalPayload = {
    id_workflow: REFERRAL_WORKFLOW_ID,
    method: "post",
    request: innerPayload
  };

  /**
   * El uso de 'no-cors' es necesario para evitar el preflight de CORS con Google Apps Script.
   * Nota: En este modo no podemos leer la respuesta (opaque response), pero los datos se envían correctamente.
   */
  return fetch(PROXY_SCRIPT_URL, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify(finalPayload)
  });
};
